
class InStockTimer extends HTMLElement {
    constructor() {
        super();
        this.timerElement = this.querySelector('.timer');
        this.dateElement = this.querySelector('.date-product');
        this.timerInterval = null;
    }

    connectedCallback() {
        this.startTimer();
    }

    disconnectedCallback() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }

    startTimer() {
        this.updateTimer();
        this.timerInterval = setInterval(() => this.updateTimer(), 1000);
    }

    updateTimer() {
        const d = new Date();
        const d1 = new Date();
        d.setHours(d1.getHours() + 9);
      
        const hours = 23 - d.getHours();
        let min = 59 - d.getMinutes();
        let sec = 59 - d.getSeconds();
      
        min = min.toString().padStart(2, '0');
        sec = sec.toString().padStart(2, '0');
        
        if (this.timerElement) {
            this.timerElement.textContent = `${hours}:${min}:${sec}s`;
        }

        const currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        const currentDateNew = new Date(new Date().getTime() + 120 * 60 * 60 * 1000);
        
        const day = currentDateNew.getDate();
        const daySuffix = this.getDaySuffix(day);
        
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
      
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      
        if (this.dateElement) {
            this.dateElement.textContent = `${days[currentDateNew.getDay()]}, ${day}${daySuffix} ${monthNames[currentDateNew.getMonth()]}`;
        }
    }

    getDaySuffix(day) {
        if (day > 3 && day < 21) return 'th';

        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }
}

customElements.define('in-stock-timer', InStockTimer);
